import { DuotoneSgmLogoSchema } from '@/components/DuotoneSgmLogo/styles/DuotoneSgmLogo.styles';

export const duotoneSgmLogoStyles: DuotoneSgmLogoSchema = {
  sgmLogo: {
    w: '9',
    h: 'auto',
    color: 'beta.200',
  },
};
